export default __webpack_public_path__ + "static/media/NOTATION_-_POST_ON_FHP_IN_GOOD_SPOT.32a6dc49.png";